import clsx from 'clsx'
import { inspectionAge } from '@/lib/inspectionAge'

/**
 * Amber chip for a pallet whose PPECB inspection is close to, or past, its limit
 * (21 d soft citrus, 28 d hard). Shows nothing when the inspection is fresh or the
 * pallet has no inspection date. A warning only: it never blocks a load.
 * Logic: src/lib/inspectionAge.ts.
 */
export default function InspectionAgeChip({ inspectedAt, commodity, className, show = true }: {
  inspectedAt: string | null | undefined
  commodity: string | null | undefined
  className?: string
  /** False hides the chip (the caller passes a comparison, so the caller carries no extra branch). */
  show?: boolean
}) {
  const age = inspectionAge(inspectedAt, commodity)
  if (!show || age.kind !== 'amber' && age.kind !== 'stale') return null
  return (
    <span
      data-testid="inspection-age-chip"
      data-kind={age.kind}
      title={age.detail}
      className={clsx(
        'text-caption rounded-full px-2 py-0.5 bg-warning-soft text-warning whitespace-nowrap',
        age.kind === 'stale' && 'font-semibold border border-warning-edge',
        className,
      )}>
      {age.kind === 'stale' ? `${age.chip} · past the limit` : age.chip}
    </span>
  )
}
